﻿export const nursing500 = '#00b1eb';
export const nursing200 = '#65e2ff';
export const nursing800 = '#0081b7';

export const silviaA500 = '#efeeee';
export const claraA500 = '#706f6f';
export const amberA500 = '#f7a823';
export const lilyA500 = '#ec619f';
export const siennaA500 = '#ec6608';
export const magentaA500 = '#c7017f';

export const grey50 = '#fafafa';
export const grey100 = '#f5f5f5';
export const grey200 = '#eeeeee';
export const grey300 = '#e0e0e0';
export const grey400 = '#bdbdbd';
export const grey500 = '#9e9e9e';
export const grey600 = '#757575';
export const grey700 = '#616161';
export const grey800 = '#424242';
export const grey900 = '#212121';

export const black = '#000000';
export const white = '#ffffff';

export const red500 = '#F44336';

export const primary = '#ff0000';
